import React from "react";
import { Building, Hash, Phone, MapPin, FileText, CheckCircle2 } from "lucide-react";
import { FormInput, FormSelect, SearchableSelect, FormTextarea } from "./SharedFormComponents";
import { INDIAN_STATES } from "../../../../constants/globalConstants";

export const StoreForm = ({ form, errors, handleInputChange }) => {
  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-2 duration-300">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormInput
          icon={<Building size={14} />}
          label="Store Name"
          required
          field="storeName"
          value={form.storeName}
          onChange={handleInputChange}
          error={errors.storeName}
          placeholder="Enter store name"
        />
        <FormInput
          icon={<Hash size={14} />}
          label="Store Code"
          field="storeCode"
          value={form.storeCode}
          onChange={handleInputChange}
          error={errors.storeCode}
          placeholder="e.g. STR-001"
        />
        <FormInput
          icon={<Phone size={14} />}
          label="Mobile"
          field="mobile"
          value={form.mobile}
          onChange={handleInputChange}
          error={errors.mobile}
          placeholder="Contact number"
        />
        <FormSelect
          icon={<CheckCircle2 size={14} />}
          label="Status"
          required
          field="status"
          options={[
            { value: "ACTIVE", label: "Active" },
            { value: "INACTIVE", label: "Inactive" },
          ]}
          value={form.status || "ACTIVE"}
          onChange={handleInputChange}
          error={errors.status}
        />
      </div>

      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="md:col-span-2">
            <FormTextarea
              icon={<MapPin size={14} />}
              label="Address Line 1"
              required
              field="addressLine1"
              value={form.addressLine1}
              onChange={handleInputChange}
              error={errors.addressLine1}
              placeholder="Building name, street..."
            />
          </div>
          <div className="md:col-span-2">
            <FormTextarea
              icon={<MapPin size={14} />}
              label="Address Line 2 (Optional)"
              field="addressLine2"
              value={form.addressLine2}
              onChange={handleInputChange}
              error={errors.addressLine2}
              placeholder="Area, Landmark..."
            />
          </div>
          <SearchableSelect
            icon={<MapPin size={14} />}
            label="State"
            required
            field="state"
            options={INDIAN_STATES.map((s) => ({ value: s, label: s }))}
            value={form.state || ""}
            onChange={handleInputChange}
            error={errors.state}
            placeholder="Select State"
          />
          <FormInput
            icon={<Building size={14} />}
            label="City"
            required
            field="city"
            value={form.city}
            onChange={handleInputChange}
            error={errors.city}
            placeholder="Enter city"
          />
          <FormInput
            icon={<Hash size={14} />}
            label="Pincode"
            required
            field="pincode"
            value={form.pincode}
            onChange={handleInputChange}
            error={errors.pincode}
            placeholder="123456"
          />
        </div>
      </div>

      <div className="md:col-span-2">
        <FormTextarea
          icon={<FileText size={14} />}
          label="Description"
          field="description"
          value={form.description}
          onChange={handleInputChange}
          error={errors.description}
          placeholder="Additional store notes..."
        />
      </div>
    </div>
  );
};
